import { RotateIcon, CheckIcon } from "../../icons";
import { PageBadge, PageRecord } from "../recordDefinition.types";

const syncPending = (record: PageRecord) =>
  record.g4api_apisynchronisationrequired === true;

export const contactPageBadges: PageBadge[] = [
  {
    id: "state",
    label: (record) => (record.statecode === 0 ? "Active" : "Inactive"),
    variant: (record) => (record.statecode === 0 ? "success" : "warning"),
  },
  {
    id: "sync",
    label: (record) => (syncPending(record) ? "Pending Sync" : "Synced"),
    variant: (record) => (syncPending(record) ? "warning" : "success"),
    icon: (record) => (syncPending(record) ? RotateIcon : CheckIcon),
  },
];
